import React from 'react';
import { ISVGType } from './SVGType';

const WalletEllipse: React.FC<ISVGType> = (props) => {
  const { height = 22, width = 22, color = "#0CAB7C" } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
    >
      <g filter="url(#filter0_d_98_1953)">
        <circle cx="11" cy="7" r="4" fill={color} />
      </g>
      <defs>
        <filter
          id="filter0_d_98_1953"
          x="0"
          y="0"
          width={width}
          height={height}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha" />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="3.5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0470588 0 0 0 0 0.670588 0 0 0 0 0.486275 0 0 0 0.3 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_98_1953"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_98_1953"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};

export default WalletEllipse;
